module.exports = __webpack_public_path__ + "img/4.1182f173.jpg";